import React, {ChangeEventHandler, FC, useCallback, useMemo, useState} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectCities} from 'modules/locations/selectors';
import {applyCity, changeLocation} from 'modules/locations/thunks';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {ModalOverlay} from 'modules/modals/components/ModalOverlay';
import {RegularModal} from 'modules/modals/components/RegularModal';
import {MODALS} from 'modules/modals/constants';
import {Modal} from 'modules/modals/components/Modal';
import {hideModal} from 'modules/modals/thunks';
import Icon from 'components/Icon';
import {useUserCity} from 'modules/locations/hooks/useUserCity';

interface IProps {}

export const CitiesModalNew: FC<IProps> = ({}) => {
    const cityList = useAppSelector(selectCities);
    const currentCity = useUserCity();

    const dispatch = useAppDispatch();
    const [cityId, setCityId] = useState<number>(currentCity?.id || 0);

    const handleCityChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
        (e) => {
            const newCityId = Number(e.target.value);

            setCityId(Number(e.target.value));

            dispatch(changeLocation(newCityId));

            dispatch(applyCity);
            dispatch(hideModal(MODALS.CITY_CHANGE_NEW.name));
        },
        [dispatch],
    );

    const renderCityList = useMemo(() => {
        if (!cityList) {
            return [];
        }

        return cityList.map((city, index) => {
            return (
                <li
                    className={style.cityItem}
                    data-autotest-target={'header'}
                    data-autotest-target-id={'header-link-location'}
                    key={index}
                >
                    <label className={style.cityLabel} htmlFor={city.id.toString()}>
                        <Typography element={'div'} variant={'label-16-r'}>
                            {city.title}
                        </Typography>
                    </label>
                    <input
                        checked={cityId === city.id}
                        className={style.cityInput}
                        id={city.id.toString()}
                        name={city.id.toString()}
                        onChange={handleCityChange}
                        type={'radio'}
                        value={city.id}
                    />
                    {city.id === currentCity?.id && <Icon className={style.checkIcon} icon={'checkmark-thin'} />}
                </li>
            );
        });
    }, [currentCity?.id, cityId, cityList, handleCityChange]);

    return (
        <Modal name={MODALS.CITY_CHANGE_NEW.name} willMount={true} hasPortal={true}>
            <RegularModal
                className={style.cityNewModal}
                classNameCloseButton={style.closeButton}
                hasClose={true}
                overlay={<ModalOverlay />}
            >
                <div className={style.header}>
                    <Typography variant={'title-24-r'}>Город</Typography>
                </div>
                <div className={style.citiesListContainer}>
                    <ul className={style.citiesList}>{renderCityList}</ul>
                </div>
            </RegularModal>
        </Modal>
    );
};
